function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SolomonIslandsFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_1572",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_1572)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#3D58DB"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_1572",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_1572)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 21H24V3L0 21Z",
        fill: "#579D20"
      }), /*#__PURE__*/_jsx("path", {
        d: "M-0.58652 21.5589L-1.93933 19.6869L25.2564 1.53426L26.6092 3.40633L-0.58652 21.5589Z",
        fill: "#FECA00"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.73995 7.90996L3.76262 7.20061L4.83364 7.83825L4.45852 6.69501L5.20754 5.87694H4.19271L3.76262 4.67554L3.33254 5.87694L2.31598 5.91891L3.06673 6.69501L2.73995 7.90996ZM6.98358 7.90996L8.00626 7.20061L9.07727 7.83825L8.70215 6.69501L9.45117 5.87694H8.43634L8.00626 4.67554L7.57617 5.87694L6.55961 5.91891L7.31036 6.69501L6.98358 7.90996Z",
        fill: "#F7FCFF"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.98598 10.0909L6.00866 9.38158L7.07967 10.0192L6.70455 8.87599L7.45357 8.05791H6.43874L6.00866 6.85651L5.57857 8.05791L4.56201 8.09988L5.31276 8.87599L4.98598 10.0909ZM3.76262 11.7006L2.73995 12.41L3.06673 11.195L2.31598 10.4189L3.33254 10.3769L3.76262 9.17554L4.19271 10.3769H5.20754L4.45852 11.195L4.83364 12.3382L3.76262 11.7006ZM8.00626 11.7006L6.98358 12.41L7.31036 11.195L6.55961 10.4189L7.57617 10.3769L8.00626 9.17554L8.43634 10.3769H9.45117L8.70215 11.195L9.07727 12.3382L8.00626 11.7006Z",
        fill: "#F7FCFF"
      })]
    })]
  })]
}));
//# sourceMappingURL=SolomonIslands.js.map